import { FunctionComponent, SVGProps } from 'react';

import { TrialDenovoIcon, TrialEnhanceIcon } from '#shared';

import { ENOPTrialProgramName } from '../../enums';

export const TRIAL_ICONS: Record<
  ENOPTrialProgramName,
  FunctionComponent<SVGProps<SVGSVGElement>>
> = {
  [ENOPTrialProgramName.ENHANCE]: TrialEnhanceIcon,
  [ENOPTrialProgramName.DENOVO]: TrialDenovoIcon,
};

export const getTrialIcon = (programName: ENOPTrialProgramName) =>
  TRIAL_ICONS[programName];
